module.exports = __webpack_public_path__ + "static/media/autotsne.da58b6ab.gif";